export const SET_LAST_DEPOSIT_ITEM = 'SET_LAST_DEPOSIT_ITEM';
export const SET_FORM_ERRORS = 'SET_FORM_ERRORS';
export const REMOVE_FORM_ERRORS = 'REMOVE_FORM_ERRORS';
